import { CheckCircle, PlusAddCircle, Clock, AlertErrorCircle } from '@/assets/icons'
import { FileAddDisposition, FileAddPreviewItem } from '../../store/schemas'

export type DispositionDisplay = { text: string; className: string; Icon: typeof CheckCircle; blocking: boolean; loading?: boolean }

/**
 * Maps a preview disposition to its status treatment (icon + colored copy). NEW / ALREADY_INCLUDED
 * match Figma node 8716:98820 (Add Files - Added). FAILED_WILL_RETRY has no Figma frame; we do not
 * auto-retry, so it reads as a failure the user must act on ("File failed, please retry").
 */
export function dispositionDisplay(item: FileAddPreviewItem | undefined): DispositionDisplay | null {
  if (!item) return null
  switch (item.disposition) {
    case FileAddDisposition.NEW:
      return { text: 'New file · Ready to process', className: 'text-green-800', Icon: PlusAddCircle, blocking: false }
    case FileAddDisposition.ALREADY_INCLUDED:
      return { text: 'In chronology · This file will not be reprocessed', className: 'text-brand-neutral-600', Icon: CheckCircle, blocking: false }
    case FileAddDisposition.FAILED_WILL_RETRY:
      return { text: 'File failed, please retry', className: 'text-red-800', Icon: AlertErrorCircle, blocking: false }
    case FileAddDisposition.NOT_READY:
      return { text: 'Still processing · Wait for processing to finish', className: 'text-yellow-700', Icon: Clock, blocking: true, loading: true }
    case FileAddDisposition.NOT_IN_MATTER:
      return { text: 'Not available in this matter', className: 'text-red-700', Icon: AlertErrorCircle, blocking: true }
  }
}
